"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VkStartParams = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var VkStartParams = /*#__PURE__*/function () {
  function VkStartParams(params) {
    (0, _classCallCheck2["default"])(this, VkStartParams);
    (0, _defineProperty2["default"])(this, "params", void 0);
    this.params = params;
  }

  (0, _createClass2["default"])(VkStartParams, [{
    key: "getValue",
    value: function getValue(name) {
      return this.params[name];
    }
  }, {
    key: "hasValue",
    value: function hasValue(name) {
      return this.params[name] !== undefined;
    }
  }, {
    key: "getIntValue",
    value: function getIntValue(name) {
      var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (!this.hasValue(name)) {
        return def;
      }

      var value = parseInt(this.getValue(name), 10);

      if (!isNaN(value)) {
        return value;
      }

      return def;
    }
  }, {
    key: "getStrValue",
    value: function getStrValue(name) {
      var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (!this.hasValue(name)) {
        return def;
      }

      var value = this.getValue(name);

      if (typeof value === 'string') {
        return value;
      }

      return (value || '').toString();
    }
    /**
     * @param {String|String[]} scope
     * @return {boolean}
     */

  }, {
    key: "hasTokenSettings",
    value: function hasTokenSettings(scope) {
      var _this = this;

      if (Array.isArray(scope)) {
        return !scope.some(function (scope) {
          return !_this._hasTokenSettingsScope(scope);
        });
      }

      return this._hasTokenSettingsScope(scope);
    }
    /**
     * @return {boolean}
     */

  }, {
    key: "hasGroup",
    value: function hasGroup() {
      return !!this.getValue('vk_group_id');
    }
    /**
     * @return {boolean}
     */

  }, {
    key: "isDesktop",
    value: function isDesktop() {
      return this.getValue('vk_platform') === VkStartParams.DESKTOP_WEB;
    }
    /**
     * Мобильные клиенты
     * @return {boolean}
     */

  }, {
    key: "isMobileApp",
    value: function isMobileApp() {
      return this.getValue('vk_platform') === VkStartParams.MOBILE_ANDROID || this.getValue('vk_platform') === VkStartParams.MOBILE_IPHONE || this.getValue('vk_platform') === VkStartParams.MOBILE_ANDROID_MESSENGER || this.getValue('vk_platform') === VkStartParams.MOBILE_IPHONE_MESSENGER;
    }
    /**
     * @return {boolean}
     */

  }, {
    key: "isMobileWeb",
    value: function isMobileWeb() {
      return this.getValue('vk_platform') === VkStartParams.MOBILE_WEB;
    }
    /**
     * Только приложения под андроид и iOS
     * @return {boolean}
     */

  }, {
    key: "isMobileAppVkOnly",
    value: function isMobileAppVkOnly() {
      return this.getValue('vk_platform') === VkStartParams.MOBILE_ANDROID || this.getValue('vk_platform') === VkStartParams.MOBILE_IPHONE;
    }
  }, {
    key: "isGroupAdmin",
    value: function isGroupAdmin() {
      return this.getValue('vk_viewer_group_role') === VkStartParams.ADMIN;
    }
  }, {
    key: "isGroupEditor",
    value: function isGroupEditor() {
      return this.getValue('vk_viewer_group_role') === VkStartParams.EDITOR;
    }
  }, {
    key: "isGroupModerator",
    value: function isGroupModerator() {
      return this.getValue('vk_viewer_group_role') === VkStartParams.MODER;
    }
    /**
     * vk_viewer_group_role == member
     * Чтобы проверить состоит ли пользователь в сообществе используй isGroupMemberOrAdmin
     * @return {boolean}
     */

  }, {
    key: "isGroupMember",
    value: function isGroupMember() {
      return this.getValue('vk_viewer_group_role') === VkStartParams.MEMBER;
    }
    /**
     * Пользователь состоит в сообществе или администратор/модервтор/редактор
     * @return {boolean}
     */

  }, {
    key: "isGroupMemberOrAdmin",
    value: function isGroupMemberOrAdmin() {
      return this.isGroupMember() || this.isGroupAdmin() || this.isGroupEditor() || this.isGroupModerator();
    }
    /**
     * Пользователь администратор/модервтор/редактор
     * @return {boolean}
     */

  }, {
    key: "isGroupAnyAdmin",
    value: function isGroupAnyAdmin() {
      return this.isGroupAdmin() || this.isGroupEditor() || this.isGroupModerator();
    }
  }, {
    key: "notInGroup",
    value: function notInGroup() {
      return this.getStrValue('vk_viewer_group_role') === VkStartParams.NONE || !this.hasValue('vk_viewer_group_role');
    }
    /**
     * @private
     * @param {String} singleScope
     * @return {boolean}
     * @private
     */

  }, {
    key: "_hasTokenSettingsScope",
    value: function _hasTokenSettingsScope(singleScope) {
      var settings = this.getAccessTokenSettings();
      return settings.includes(singleScope);
    }
  }, {
    key: "getUserId",
    value: function getUserId() {
      return this.getIntValue('vk_user_id');
    }
  }, {
    key: "getAppId",
    value: function getAppId() {
      return this.getIntValue('vk_app_id', 0);
    }
  }, {
    key: "isAppUser",
    value: function isAppUser() {
      return this.getValue('vk_is_app_user');
    }
  }, {
    key: "areNotificationsEnabled",
    value: function areNotificationsEnabled() {
      return this.getIntValue('vk_are_notifications_enabled', 0) === 1;
    }
  }, {
    key: "getLanguage",
    value: function getLanguage() {
      return this.getStrValue('vk_language');
    }
  }, {
    key: "getRef",
    value: function getRef() {
      return this.getStrValue('vk_ref');
    }
  }, {
    key: "getAccessTokenSettings",
    value: function getAccessTokenSettings() {
      return this.getStrValue('vk_access_token_settings').split(',');
    }
    /**
     * 0 если без группы
     */

  }, {
    key: "getGroupId",
    value: function getGroupId() {
      return this.getIntValue('vk_group_id', 0);
    }
  }, {
    key: "getViewerGroupRole",
    value: function getViewerGroupRole() {
      return this.getStrValue('vk_viewer_group_role');
    }
  }, {
    key: "getPlatform",
    value: function getPlatform() {
      return (this.getValue('vk_platform') || '').toString();
    }
  }, {
    key: "isFavorite",
    value: function isFavorite() {
      return parseInt(this.getValue('vk_is_favorite') || '0') === 1;
    }
  }, {
    key: "getSign",
    value: function getSign() {
      return (this.getValue('sign') || '').toString();
    }
  }, {
    key: "isInGroup",
    value: function isInGroup() {
      return this.groupId && this.groupId > 0;
    }
    /**
     * @param {Boolean} value
     */

  }, {
    key: "isAdmin",
    value: function isAdmin() {
      return this.isInGroup() && this.viewerGroupRole === VkStartParams.VIEWER_GROUP_ROLE_ADMIN;
    }
  }, {
    key: "isModerator",
    value: function isModerator() {
      return this.isInGroup() && this.viewerGroupRole === VkStartParams.VIEWER_GROUP_ROLE_MODERATOR;
    }
  }, {
    key: "isEditor",
    value: function isEditor() {
      return this.isInGroup() && this.viewerGroupRole === VkStartParams.VIEWER_GROUP_ROLE_EDITOR;
    }
  }, {
    key: "isMember",
    value: function isMember() {
      return this.isInGroup() && this.viewerGroupRole === VkStartParams.VIEWER_GROUP_ROLE_MEMBER;
    }
  }, {
    key: "isNobody",
    value: function isNobody() {
      return this.isInGroup() && this.viewerGroupRole === VkStartParams.VIEWER_GROUP_ROLE_NOBODY;
    }
  }, {
    key: "isMobile",
    value: function isMobile() {
      return this.platform !== 'desktop_web';
    }
    /**
     * @return string
     */

  }, {
    key: "getLangCode",
    value: function getLangCode() {
      if (this.language === VkStartParams.LANG_UKR) {
        return 'ua';
      }

      return this.language;
    }
  }, {
    key: "userId",

    /**
     * vk_user_id (integer) — идентификатор пользователя, запустившего сервис.
     * @returns {number}
     */
    get: function get() {
      return this.getIntValue('vk_user_id');
    }
    /**
     *  vk_app_id (integer) — идентификатор запущенного приложения.
     * @returns {number}
     */

  }, {
    key: "appId",
    get: function get() {
      return this.getIntValue('vk_app_id');
    }
  }, {
    key: "language",
    get: function get() {
      return this.getStrValue('vk_language');
    }
  }, {
    key: "accessTokenSettings",
    get: function get() {
      return this.getStrValue('vk_access_token_settings');
    }
    /**
     * @param {boolean} value
     */

    /**
     * group_id (integer) — идентификатор сообщества, со страницы которого было запущено приложение
     * @returns {number}
     */

  }, {
    key: "groupId",
    get: function get() {
      return this.getIntValue('vk_group_id');
    }
    /**
     * vk_viewer_group_role (string) — роль пользователя в сообществе, из которого запущено приложение
     * admin — если пользователь является создателем или администратором сообщества;
     * editor — если пользователь является редактором сообщества;
     * moder — если пользователь является модератором сообщества;
     * member — если пользователь является участником сообщества;
     * none — если пользователь не состоит в сообществе.
     * @returns {string}
     */

  }, {
    key: "viewerGroupRole",
    get: function get() {
      return this.getStrValue('vk_viewer_group_role');
    }
    /**
     * Платформа, из которой запущен сервис
     * mobile_android — официальное приложение для Android,
     * mobile_iphone — официальное приложение для iPhone,
     * mobile_web — браузерная мобильная версия,
     * desktop_web — браузерная полная версия.
     * @returns {string}
     */

  }, {
    key: "platform",
    get: function get() {
      return this.getStrValue('vk_platform');
    }
    /**
     * vk_sign (string) — подпись переданных параметров
     * @returns {string}
     */

  }, {
    key: "sign",
    get: function get() {
      return this.getStrValue('sign');
    }
  }, {
    key: "ref",
    get: function get() {
      return this.getStrValue('vk_ref');
    }
  }]);
  return VkStartParams;
}();

exports.VkStartParams = VkStartParams;
(0, _defineProperty2["default"])(VkStartParams, "MOBILE_IPHONE_MESSENGER", 'mobile_iphone_messenger');
(0, _defineProperty2["default"])(VkStartParams, "MOBILE_ANDROID_MESSENGER", 'mobile_android_messenger');
(0, _defineProperty2["default"])(VkStartParams, "MOBILE_ANDROID", 'mobile_android');
(0, _defineProperty2["default"])(VkStartParams, "MOBILE_IPHONE", 'mobile_iphone');
(0, _defineProperty2["default"])(VkStartParams, "DESKTOP_WEB", 'desktop_web');
(0, _defineProperty2["default"])(VkStartParams, "MOBILE_WEB", 'mobile_web');
(0, _defineProperty2["default"])(VkStartParams, "ADMIN", 'admin');
(0, _defineProperty2["default"])(VkStartParams, "EDITOR", 'editor');
(0, _defineProperty2["default"])(VkStartParams, "MODER", 'moder');
(0, _defineProperty2["default"])(VkStartParams, "MEMBER", 'member');
(0, _defineProperty2["default"])(VkStartParams, "NONE", 'none');
(0, _defineProperty2["default"])(VkStartParams, "LANG_RUS", 'ru');
(0, _defineProperty2["default"])(VkStartParams, "LANG_UKR", 'uk');
(0, _defineProperty2["default"])(VkStartParams, "LANG_BEL", 'be');
(0, _defineProperty2["default"])(VkStartParams, "LANG_ENG", 'en');
(0, _defineProperty2["default"])(VkStartParams, "LANG_ESP", 'es');
(0, _defineProperty2["default"])(VkStartParams, "LANG_FIN", 'fi');
(0, _defineProperty2["default"])(VkStartParams, "LANG_DEU", 'de');
(0, _defineProperty2["default"])(VkStartParams, "LANG_ITA", 'it');
(0, _defineProperty2["default"])(VkStartParams, "VIEWER_GROUP_ROLE_ADMIN", 'admin');
(0, _defineProperty2["default"])(VkStartParams, "VIEWER_GROUP_ROLE_EDITOR", 'editor');
(0, _defineProperty2["default"])(VkStartParams, "VIEWER_GROUP_ROLE_MODERATOR", 'moder');
(0, _defineProperty2["default"])(VkStartParams, "VIEWER_GROUP_ROLE_MEMBER", 'member');
(0, _defineProperty2["default"])(VkStartParams, "VIEWER_GROUP_ROLE_NOBODY", 'none');